import { render } from "./Footer.vue?vue&type=template&id=4bcc34ce&scoped=true"
const script = {}

import "./Footer.vue?vue&type=style&index=0&id=4bcc34ce&scoped=true&lang=css"

import exportComponent from "/home/runner/work/tests-frontend/tests-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4bcc34ce"]])

export default __exports__